import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import WatchingPreviewProfileMetric from './watching-preview-profile-metric-model'
import {
  WatchingPreviewProfileMetricMetaProperties,
  WatchingPreviewProfileMetricProperties,
} from './watchingPreviewProfileMetric-property-definitions'

export async function load_watchingPreviewProfileMetrics($args: {
  uid: string
}): Promise<WatchingPreviewProfileMetric[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(
    db,
    `watchingPreviewProfileMetrics`,
    `${uid}`,
    'watchingPreviewProfileMetric',
  )
  let result: WatchingPreviewProfileMetric[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertTowatchingPreviewProfileMetric(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertTowatchingPreviewProfileMetric(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_watchingPreviewProfileMetric(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(
      db,
      `watchingPreviewProfileMetrics`,
      `${args.uid}`,
      'watchingPreviewProfileMetric',
      args.id,
    )
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_watchingPreviewProfileMetric(
  args: WatchingPreviewProfileMetric,
): Promise<WatchingPreviewProfileMetric> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let watchingPreviewProfileMetric_collection = firestore.doc(
      db,
      `watchingPreviewProfileMetrics`,
      `${owner}`,
      'watchingPreviewProfileMetric',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(WatchingPreviewProfileMetricProperties),
      ...Object.values(WatchingPreviewProfileMetricMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(watchingPreviewProfileMetric_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(
      db,
      `watchingPreviewProfileMetrics`,
      `${owner}`,
      'watchingPreviewProfileMetric',
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(WatchingPreviewProfileMetricProperties),
      ...Object.values(WatchingPreviewProfileMetricMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
